import { useQuery } from "@apollo/client/react";
import React from "react";

import { TemplateList } from "./TemplateList";
import { GET_USERS_TEMPLATES } from "../../graphql/queries/GetUsersTemplates";
import HeadingWrapper from "../common/HeadingWrapper";

export function TemplateModalList() {
  const { data } = useQuery(GET_USERS_TEMPLATES);

  return (
    <div>
      <HeadingWrapper heading={<h3>Preset Templates</h3>} />

      <div className="flex flex-col my-2 w-5/6 mx-auto">
        <TemplateList
          data={data}
          isForTemplateSelection={true}
          isPreset={true}
        />
      </div>
      <HeadingWrapper heading={<h3>Your Templates</h3>} />

      <div className="flex flex-col my-2 w-5/6 mx-auto">
        <TemplateList
          data={data}
          isForTemplateSelection={true}
          isPreset={false}
        />
      </div>
    </div>
  );
}
